export default __webpack_public_path__ + "static/media/genji-intro.3d4bad41.mp3";